export const ROUTES = {
    home: "/",
    login: "/login",
    loginError: "/login/error",
    propelAuthLogin: "/api/auth/login",
    logout: "/logout",
    sessionLogout: "/api/session/logout",
    portal: "/portal",
    start: "/start",
    startWorkspace: "/start/workspace",
    startSetup: "/start/setup",
} as const
